import { defineNuxtPlugin } from '#imports'
import { featuresForCurrentBrand } from '@b2ag/app-brands/dist/features'
import { appBrands, currentAppBrand } from '@b2ag/app-brands'
import { getConfig } from '@b2ag/micro-front-tools'

export default defineNuxtPlugin({
  name: 'equalweb',
  enforce: 'post',
  parallel: true,
  hooks: {
    'app:mounted'() {
      if (featuresForCurrentBrand.equalWeb) {
        import('@b2ag/equalweb').then(({ injectWidgetEqualWeb }) =>
          injectWidgetEqualWeb(currentAppBrand === appBrands.UMG_US ? 'CMG' : undefined, getConfig('ENVIRONMENT_NAME')),
        )
      }
    },
  },
})
